import Warung_Santuy from "../../assets/WarungSantuy.png";
import LondonBikeRides from "../../assets/LondonBikeRides_Dashboard.png";
import AW_Kiosk from "../../assets/AW.png";
import Mie_Gacoan from "../../assets/Mie_Gacoan.png";
import PetVet from "../../assets/PetVet.png";
import Sport_Rental from "../../assets/Sport_Rental.png";
import Kedai_Kopi from "../../assets/Kedai_Kopi.png";
import KingCountyHouseSales from "../../assets/KingCountyHouseSales_Dashboard.png";
import TransJakarta from "../../assets/TransJakarta_Dashboard.png";
import WA_Analysis from "../../assets/WA_Analysis.png";

export const projectsData = [
  {
    id: 1,
    image: TransJakarta,
    title: "Trans Jakarta 2021 Dashboard",
    category: "data",
    link: "https://lookerstudio.google.com/reporting/a14647a1-d48d-43ec-b2d0-0872cb2d8d42",
  },
  {
    id: 2,
    image: WA_Analysis,
    title: "WhatsApp Group Chat Analysis",
    category: "data",
    link: "https://www.kaggle.com/code/andreasmalvino/whatsapp-group-chat-analysis",
  },
  {
    id: 3,
    image: LondonBikeRides,
    title: "London Bike Rides Dashboard",
    category: "data",
    link: "https://public.tableau.com/views/LondonBikeRides_Dashboard/Dashboard1?:language=en-US&:display_count=n&:origin=viz_share_link",
  },
  {
    id: 4,
    image: KingCountyHouseSales,
    title: "King County House Sales Dashboard",
    category: "data",
    link: "https://public.tableau.com/views/HouseSalesDashboard_17022051820820/Dashboard1?:language=en-US&:display_count=n&:origin=viz_share_link",
  },
  {
    id: 5,
    image: Warung_Santuy,
    title: "Warung Santuy",
    category: "web",
    link: "https://github.com/andreasmalvino/WarungSantuy",
  },
  {
    id: 6,
    image: Kedai_Kopi,
    title: "Kedai Kopi Satu Hati",
    category: "web",
    link: "https://andreasmalvino.github.io/kedai-kopi/",
  },
  {
    id: 7,
    image: PetVet,
    title: "PetVet Mobile App UI",
    category: "design",
    link: "https://www.figma.com/proto/ECVoxeTEfzRx0BBF9cfK6h/Petvet-Apps?type=design&node-id=264-1118&t=VI4Ioast03xlakfv-1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=264%3A1118&show-proto-sidebar=1&mode=design",
  },
  {
    id: 8,
    image: Sport_Rental,
    title: "Sport Rental Mobile App UI",
    category: "design",
    link: "https://www.figma.com/proto/VyMhQP0tmxV4nmajFSmucX/(PKM)-Aplikasi-Penyewaan-Alat-Olahraga?type=design&node-id=0-2390&t=oBH0rOtIwiQ6Ic5V-1&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=0%3A2390&show-proto-sidebar=1&mode=design",
  },
  {
    id: 9,
    image: AW_Kiosk,
    title: "AW Kiosk UI",
    category: "design",
    link: "https://www.figma.com/proto/QleYbmbOVE496Aua0jgEHu/Kiosk-AW?type=design&node-id=301-98&t=jhhAzbPlNq5imiga-1&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=301%3A98&show-proto-sidebar=1&mode=design",
  },
  {
    id: 10,
    image: Mie_Gacoan,
    title: "Mie Gacoan Kiosk UI",
    category: "design",
    link: "https://www.figma.com/file/BvRXt2UICSy22lBNLycBVP/APSI-Mie-Gacoan?type=design&node-id=4%3A2&mode=design&t=rIvC7oK2Y7lhVxDp-1",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "data",
  },
  {
    name: "web",
  },
  {
    name: "design",
  },
];
